import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { setSelectedItem } from 'app/actions/user';
import { Autosizer, Image, Scrollbar } from 'app/components';
import { sessionSelector } from 'app/selectors/session';
import { selectedItemUserSelector, sortItemsUserSelector } from 'app/selectors/user';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const UserList = () => {
  const dispatch = useDispatch();
  const session = useSelector(sessionSelector);
  const selectedItem = useSelector(selectedItemUserSelector);

  const sortItems = useSelector(sortItemsUserSelector);

  const handleItemClick = (value) => {
    dispatch(setSelectedItem(value));
  };

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
        '.MuiListItem-root': {
          width: '100%',
          userSelect: 'none',
          padding: theme.spacing(0),
          borderRadius: '0',
          '.MuiChip-root': {
            padding: theme.spacing(0),
            lineHeight: '14px',
            transition: 'none',
          },
          '.MuiListItemAvatar-root': {
            minWidth: '36px',
          },
          '.MuiAvatar-circular': {
            width: '24px',
            height: '24px',
          },
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            borderRadius: '0',
          },
          '.MuiListItemText-root': {
            margin: theme.spacing(0),
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => (
                <FixedSizeList
                  height={height}
                  itemSize={36}
                  overscanCount={10}
                  itemCount={sortItems.length}
                  innerRef={contentNodeRef}
                  outerRef={scrollableNodeRef}
                  innerElementType={userListInnerElementType}
                  itemData={{
                    items: sortItems,
                    yourId: session.id,
                    selectedItem,
                    onClick: handleItemClick,
                  }}>
                  {userListItemRender}
                </FixedSizeList>
              )}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const userListInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const userListItemRender = ({ data, index, style }) => {
  const { items, yourId, selectedItem, onClick } = data;
  const item = items[index];
  return (
    <ListItem
      key={item.id}
      style={style}
      selected={item.id === selectedItem?.id}
      onClick={() => onClick(item)}
      secondaryAction={item.id === yourId && <Chip label='Ваш аккаунт' size='small' color='primary' />}
      sx={(theme) => ({
        ...(!item.active && {
          opacity: '0.5',
        }),
        ...(selectedItem?.id === item.id && {
          '.MuiChip-root': {
            color: theme.palette.primary.main,
            bgcolor: theme.palette.primary.contrastText,
          },
        }),
      })}>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <Image name={`avatar-${item.role_id}.png`} alt={`avatar-${item.role_id}`} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={item.name} />
      </ListItemButton>
    </ListItem>
  );
};

export default UserList;
